import { useMemo } from "react";

import { Button } from "@covertree/ui";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface ClaimsListHeaderProps {
  addEmptyClaim: () => void;
  numberOfClaims: number;
  disabled?: boolean;
}

export function ClaimsListHeader({
  addEmptyClaim,
  numberOfClaims,
  disabled,
}: ClaimsListHeaderProps) {
  const stepHeaderTitle = useMemo(
    () =>
      !numberOfClaims
        ? "We’ve found no past claims"
        : "We found the following claims",
    [numberOfClaims]
  );

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: theme.spacing(3),
        borderRadius: theme.spacing(1.5),
        backgroundColor: "secondary.contrastText",
        padding: theme.spacing(4),
        flexWrap: { xs: "wrap", sm: "nowrap" },
        gap: theme.spacing(2),
      })}>
      <Typography variant="h5">{stepHeaderTitle}</Typography>
      <Button
        size="small"
        variant="outlined"
        type="button"
        data-testid="addClaimItem"
        disabled={disabled}
        onClick={addEmptyClaim}>
        Add a claim
      </Button>
    </Box>
  );
}
